import { BaseModel, CURRENCY_SGD, PersonnelAppointment } from '@core/data-access';
import { Expose, Type } from 'class-transformer';
import { ApplicationStage } from '../type/application-info.type';
import { DirectorModel } from './director.model';
import { Default } from '@core/util';

export class ApplicationInfoResponse extends BaseModel {
  @Expose() accountNumber!: string;
  @Expose() companyName!: string;
  @Expose() last4NRIC!: string;
  @Expose() name!: string;
  @Expose() uen!: string;
  @Expose() stage!: ApplicationStage;
  @Expose() appointment!: PersonnelAppointment[];
  @Expose() @Type(() => DirectorModel) @Default([]) caseKeyPersonnels!: DirectorModel[];
  @Expose() @Default(CURRENCY_SGD) currencyCode!: string;
}
